/**
 *
 * @license Royal Canin
 * @contributors :
 *  - Amar YASSA
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { setShareRecommendation } from './share-recommendation.actions';

@Injectable({ providedIn: 'root' })
export class ShareRecommendationEffects {
  setShareRecommendation$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(setShareRecommendation),
        tap(() => {
          this.router.navigate(['share-recommendation']);
        })
      );
    },
    { dispatch: false }
  );

  constructor(private actions$: Actions, private router: Router) {}
}
